"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.padWithZeros = padWithZeros;
function padWithZeros(number, length) {
    return number.toString().padStart(length, "0");
}
//# sourceMappingURL=numberUtils.js.map